import React from 'react';
import { useSelector } from 'react-redux';
import { selectSiteUrl, selectBrandDisplayName } from 'core/selectors/app';
import TrendingAndSeasonalOffers from 'core/modules/TrendingAndSeasonalOffers/TrendingAndSeasonalOffers';

import config from 'core/modules/Sweeps/configs';

function SweepsInactive() {
  const siteUrl = useSelector(selectSiteUrl);
  const brandDisplayName = useSelector(selectBrandDisplayName);

  const { getInactiveSweepsH2Text } = config;
  const inactiveSweepsH2Text = getInactiveSweepsH2Text(brandDisplayName);

  return (
    <div className="mn_sweepsInactive">
      <div className="mn_sweepsHero">
        <div className="mn_contentWrap">
          <h2>{inactiveSweepsH2Text}</h2>
          <h3>But there are still lots more ways to earn miles</h3>
          <a className="mn_button" href={`${siteUrl}/p/extra-rewards.htm`}>Shop now</a>
        </div>
      </div>
      <TrendingAndSeasonalOffers />
    </div>
  );
}

export default SweepsInactive;
